import styles from "./Banner.module.css";
import circuloColorido from "../../assets/circulo_colorido.png";
import minhaFoto from "../../assets/minha_foto.png";

export default function Banner() {
  return (
    <div className={styles.banner}>
      <div className={styles.apresentacao}>
        <h1 className={styles.titulo}>Olá mundo!</h1>
        <p className={styles.paragrafo}>
          Boas vindas ao meu espaço pessoal!! Sou Daniel Pinheiro, estudante Dev
          e estou em transição de carreira para Desenvolvedor Full Stack ou
          áreas afins.
        </p>
      </div>
      <div className={styles.imagens}>
        <img
          className={styles.circuloColorido}
          src={circuloColorido}
          aria-hidden={true}
        />
        <img
          className={styles.minhaFoto}
          src={minhaFoto}
          alt="Foto do Daniel de terno"
        />
      </div>
    </div>
  );
}
